import RegisterEntry from './RegisterEntry.yaml?component';
import Registers from './Registers.yaml?component';
import RegisterView from './RegisterView.yaml?component';

export * from './form';
export * from './primitives';

export { RegisterEntry, Registers, RegisterView };
